import React, { useState, useEffect } from "react";
import DropdownTreeSelect from "react-dropdown-tree-select";

function MemoizedDomainSelect({ setSelectedDomain }) {
  const [availableDomains, setAvailableDomains] = useState([]);
  useEffect(() => {
    fetch("/outbound/users_groups_and_locations_single_select", {
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ locations: [], groups: [] }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAvailableDomains(data);
      });
  }, []);

  return (
    <DropdownTreeSelect
      data={availableDomains}
      texts={{ placeholder: "Search groups and locations" }}
      onChange={(_currNode, selectedNodes) => {
        setSelectedDomain(selectedNodes[0]);
      }}
      showDropdown="always"
      keepTreeOnSearch
      keepChildrenOnSearch
      mode="radioSelect"
      keepOpenOnSelect
    />
  );
}

export default React.memo(MemoizedDomainSelect);
